const PALETTE = [
  '#8B4513', // saddle brown
  '#2F4F4F', // dark slate gray
  '#8B0000', // dark red
  '#006400', // dark green
  '#191970', // midnight blue
  '#B8860B', // dark goldenrod
  '#556B2F', // dark olive green
  '#4B0082', // indigo
  '#800000', // maroon
  '#2E8B57', // sea green
  '#4682B4', // steel blue
  '#D2691E', // chocolate
  '#6B8E23', // olive drab
  '#708090', // slate gray
  '#9932CC', // dark orchid
  '#CD853F', // peru
  '#483D8B', // dark slate blue
  '#BC8F8F', // rosy brown
  '#5F9EA0', // cadet blue
  '#A0522D', // sienna
  '#6A5ACD', // slate blue
  '#DAA520', // goldenrod
  '#808000', // olive
  '#BDB76B', // dark khaki
];

export function entityColor(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return PALETTE[Math.abs(hash) % PALETTE.length];
}
